
<ngx-ui-loader id="master"></ngx-ui-loader>
<div ngxUiLoaderBlurred [blur]="5" class="app-container">
  <router-outlet></router-outlet>
</div>

